import { catchAsync } from './index.js';
import BaseAPI from './base.js';

class TradenameAPIService extends BaseAPI {
    constructor() {
        super({
            baseUrl: process.env.REACT_APP_API_URL,
            cacheKeyPattern: 'tradename-${method}-${url}',
            cacheExpiration: 10 * 60 * 1000, // 10 minutes
            debug: false
        });
    }

    getByLetterPage = catchAsync(async (letter, page) => {
        return this.request(`/tradenames?letter=${letter}&page=${page}`);
    });

    search = catchAsync(async (keyword, page = 1) => {
        return this.request(
            `/search/tradenames?keyword=${encodeURIComponent(keyword)}&page=${page}`
        );
    });

    getOne = catchAsync(async (uri) => {
        return this.request(`/tradenames/${uri}`);
    });

    getFeatures = catchAsync(async () => {
        return this.request(`/tradenames/feature`);
    });

    /**
     * Test cache functionality
     * @returns {Promise<void>}
     */
    async testCache() {
        console.log('=== Starting Tradename Cache Test ===');
        
        // Test 1: First request (should hit API)
        console.log('\nTest 1: First request (should hit API)');
        const firstResult = await this.getOne('aspirin-500mg');
        console.log('First request result:', firstResult);

        // Test 2: Second request (should hit cache)
        console.log('\nTest 2: Second request (should hit cache)');
        const secondResult = await this.getOne('aspirin-500mg');
        console.log('Second request result:', secondResult);

        // Test 3: Different endpoint (should hit API)
        console.log('\nTest 3: Different endpoint (should hit API)');
        const searchResult = await this.search('aspirin');
        console.log('Search result:', searchResult);

        // Test 4: Cache statistics
        console.log('\nTest 4: Cache Statistics');
        const stats = this.getCacheStats();
        console.log('Cache stats:', stats);

        console.log('\n=== Tradename Cache Test Complete ===');
    }
}

const TradenameAPI = new TradenameAPIService();
export default TradenameAPI; 